import PropTypes from "prop-types"
import React, { useEffect } from "react"
import { connect } from "react-redux"
import { canAccessCpPage } from "helpers/cpAccessPolicy"

// MetisMenu
import MetisMenu from "metismenujs"
import { withRouter } from "react-router-dom"
import { Link } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"

const normalizePath = path => path?.replace(/\/+$/, "") || "/"

const menuPathMatches = (currentPath, menuPath) => {
  const current = normalizePath(currentPath)
  const menu = normalizePath(menuPath)

  return menu !== "/" && (current === menu || current.startsWith(`${menu}/`))
}

export const SidebarContent = props => {
  useEffect(() => {
    const menu = new MetisMenu("#side-menu")

    return () => menu.dispose?.()
  }, [])

  useEffect(() => {
    const pathName = props.location.pathname
    const menu = document.getElementById("side-menu")

    if (!menu) return

    menu
      .querySelectorAll(".active, .mm-active, .mm-show")
      .forEach(element =>
        element.classList.remove("active", "mm-active", "mm-show")
      )
    menu
      .querySelectorAll('[aria-expanded="true"]')
      .forEach(element => element.setAttribute("aria-expanded", "false"))

    const matchingMenuItem = Array.from(menu.getElementsByTagName("a"))
      .filter(item => menuPathMatches(pathName, item.pathname))
      .sort((firstItem, secondItem) =>
        secondItem.pathname.length - firstItem.pathname.length
      )[0]

    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem)
    }
  }, [props.location.pathname])

  function activateParentDropdown(item) {
    item.classList.add("active")
    const parent = item.parentElement

    const parent2El = parent.childNodes[1]
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
      parent2El.setAttribute("aria-expanded", "true")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag
        parent2.setAttribute("aria-expanded", "true")

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          parent3.childNodes[0].setAttribute("aria-expanded", "true")
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      return false
    }
    return false
  }

  return (
    <React.Fragment>
      <div id="sidebar-menu">
        <ul className="metismenu list-unstyled" id="side-menu">
          <li className="menu-title">{props.t("Menu")} </li>
          <li>
            <Link to="/dashboard" className="waves-effect">
              <i className="bx bx-home-circle"></i>
              <span>{props.t("Dashboards")}</span>
            </Link>
          </li>

          <li>
            <Link to="/#" className="has-arrow waves-effect">
              <i className="bx bxs-user-detail"></i>
              <span>{props.t("Users Management")}</span>
            </Link>
            <ul className="sub-menu" aria-expanded="false">
              <li>
                <Link to="/accounts/players">{props.t("Users")}</Link>
              </li>
              <li>
                <Link to="/accounts/clubs">{props.t("Clubs")}</Link>
              </li>
              <li>
                <Link to="/accounts/clubs-leads">
                  {props.t("Club Business Leads")}
                </Link>
              </li>
              <li>
                <Link to="/accounts/organizers">{props.t("Organizers")}</Link>
              </li>
              <li>
                <Link to="/accounts/admins">{props.t("Admins")}</Link>
              </li>
            </ul>
          </li>

          <li>
            <Link to="/events-management" className=" waves-effect">
              <i className="bx bx-calendar-event"></i>
              <span>{props.t("Events Management")}</span>
            </Link>
          </li>

          {canAccessCpPage(props.userDetails, "/events-planner") && <li>
            <Link to="/events-planner" className="waves-effect">
              <i className="bx bx-calendar-check"></i>
              <span>{props.t("Events Planner")}</span>
            </Link>
          </li>}

          <li>
            <Link to="/friendly-matches" className=" waves-effect">
              <i className="bx bx-tennis-ball"></i>
              <span>{props.t("Friendly Matches")}</span>
            </Link>
          </li>

          {canAccessCpPage(props.userDetails, "/bookings-management") && <li>
            <Link to="/bookings-management" className="waves-effect">
              <i className="bx bx-calendar"></i>
              <span>{props.t("Bookings Management")}</span>
            </Link>
          </li>}

          {canAccessCpPage(props.userDetails, "/payments-management") && <li>
            <Link
              to="/payments-management"
              className={` waves-effect ${
                props.location.pathname === "/payments-management" &&
                "mm-active"
              }`}
            >
              <i className="bx bx-credit-card"></i>
              <span>{props.t("Payments Management")}</span>
            </Link>
          </li>}

          {canAccessCpPage(props.userDetails, "/extended-analytics") && <li>
          <Link
              to="/extended-analytics"
              className={` waves-effect ${
                props.location.pathname === "/extended-analytics" &&
                "mm-active"
              }`}
            >
              <i className="bx bx-line-chart"></i>
              <span>{props.t("Extended Analytics")}</span>
            </Link>
          </li>}

          {canAccessCpPage(props.userDetails, "/marketing") && <li>
            <Link to="/#" className="has-arrow waves-effect">
              <i className="bx bx-broadcast"></i>
              <span>{props.t("Marketing")}</span>
            </Link>
            <ul className="sub-menu" aria-expanded="false">
              <li>
                <Link to="/marketing/newsletters">{props.t("Newsletters")}</Link>
              </li>
            </ul>
          </li>}

          <li>
            <Link
              to="/penalties-management"
              className={` waves-effect ${
                props.location.pathname === "/penalties-management" &&
                "mm-active"
              }`}
            >
              <i className="bx bx-block"></i>
              <span>{props.t("Penalties Management")}</span>
            </Link>
          </li>

          {canAccessCpPage(props.userDetails, "/reports-management") && <li>
            <Link
              to="/reports-management"
              className={` waves-effect ${
                props.location.pathname === "/reports-management" &&
                "mm-active"
              }`}
            >
              <i className="bx bx-error-alt"></i>
              <span>{props.t("Reports Management")}</span>
            </Link>
          </li>}

          {canAccessCpPage(props.userDetails, "/rankings-management") && <li>
            <Link
              to="/rankings-management"
              className={` waves-effect ${
                props.location.pathname === "/rankings-management" &&
                "mm-active"
              }`}
            >
              <i className="bx bx-list-ol"></i>
              <span>{props.t("Rankings")}</span>
            </Link>
          </li>}

          {canAccessCpPage(props.userDetails, "/system-settings") && <li>
            <Link
              to="/system-settings"
              className={` waves-effect ${
                props.location.pathname === "/system-settings" && "mm-active"
              }`}
            >
              <i className="bx bx-wrench"></i>
              <span>{props.t("System Settings")}</span>
            </Link>
          </li>}

          {canAccessCpPage(props.userDetails, "/tournament-feedback") && <li>
            <Link
              to="/tournament-feedback"
              className={` waves-effect ${
                props.location.pathname.startsWith("/tournament-feedback") && "mm-active"
              }`}
            >
              {/* bx-message-square-detail, the prototype's icon, is not in CP's boxicons set (SidebarContent.test.js). */}
              <i className="bx bx-message-square-dots"></i>
              <span>{props.t("Tournament feedback")}</span>
            </Link>
          </li>}

          {canAccessCpPage(props.userDetails, "/settings/partners") && <li>
            <Link
              to="/settings/partners"
              className={` waves-effect ${
                props.location.pathname === "/settings/partners" && "mm-active"
              }`}
            >
              <i className="bx bx-buildings"></i>
              <span>{props.t("Parteneri")}</span>
            </Link>
          </li>}

          {canAccessCpPage(props.userDetails, "/logistics") && <li>
            <Link to="/#" className="has-arrow waves-effect">
              <i className="bx bx-package"></i>
              <span>{props.t("Logistics")}</span>
            </Link>
            <ul className="sub-menu" aria-expanded="false">
              <li>
                <Link to="/logistics/warehouse">{props.t("Warehouse")}</Link>
              </li>
              <li>
                <Link to="/logistics/sheets">{props.t("Sheets")}</Link>
              </li>
              <li>
                <Link to="/logistics/shipments">{props.t("Shipments")}</Link>
              </li>
              <li>
                <Link to="/logistics/stock">{props.t("Stock")}</Link>
              </li>
              <li>
                <Link to="/logistics/products">{props.t("Products")}</Link>
              </li>
              <li>
                <Link to="/logistics/estimates">{props.t("Estimates")}</Link>
              </li>
              <li>
                <Link to="/logistics/settings">{props.t("Settings")}</Link>
              </li>
            </ul>
          </li>}

          {/* PRD 14 I5 — the Tenis10 migration's support page: its own section, last (nothing below reads as part of it) */}
          <li className="menu-title">{props.t("Tenis10")}</li>
          <li>
            <Link to="/accounts/tenis10-claims" className="waves-effect">
              <i className="bx bx-link-alt"></i>
              <span>{props.t("Tenis10 Claims")}</span>
            </Link>
          </li>
        </ul>
      </div>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default connect(({ session }) => ({ userDetails: session?.userDetails }))(withRouter(withTranslation()(SidebarContent)))
